import CloseButton from "../../components/ui/close_button/CloseButton";
import InputList from "../../components/ui/input_list/InputList";
import InputRadioMulti from "../../components/ui/input_radio_multi/InputRadioMulti";
import styles from "./styles/Customization.module.css";

const CustomSearchField = ({
    groupType, // string - the type of the group (e.g. tickets)
    item, // object - the group object (e.g. customizations?.pos?.tickets.group)
    field, // object - the field object (e.g. customizations?.pos?.tickets.group.fields.field)
    idx, // number - the index of the group
    idx2, // number - the index of the field
    handleNestedChange, // function - handle nested changes
    deleteField, // function - delete a field
    categories, // array - the fields names array
    customizations, // object - the customizations object
}) => {
    return (
        <div className={`v-flex-container`}>
            <div className={`flex-container`}>
                <InputList
                    inputId={`${groupType}-G-${idx}-F${idx2}-${field?.id}`}
                    // inputId={field?.id}
                    inputValue={field?.fieldName}
                    values={categories}
                    handleChangeFunction={(event) =>
                        handleNestedChange(
                            event,
                            `pos.${groupType}.${idx}.fields.${idx2}.fieldName`
                        )
                    }
                />
                {/* Delete field button only if there is more than one */}
                {item?.fields.length !== 1 && (
                    <div className={`${styles.field_delete_button}`}>
                        <CloseButton
                            type={"button"}
                            onClickFuction={() =>
                                deleteField(groupType, idx, idx2)
                            }
                        />
                    </div>
                )}
            </div>
            {/* Show The relation option if more than one field */}
            {idx2 !== item?.fields.length - 1 && (
                <div
                    className={`${styles.main_radio_container} flex-container`}
                >
                    {/* The relation radio buttons, can be or,and */}
                    <InputRadioMulti
                        options={["or", "and"]}
                        value={
                            customizations?.pos?.[groupType][idx]?.fields[idx2]
                                ?.rel
                        }
                        inputId={`${groupType}-G-${idx}-F${idx2}`}
                        handleChangeFunction={(event) =>
                            handleNestedChange(
                                event,
                                `pos.${groupType}.${idx}.fields.${idx2}.rel`
                            )
                        }
                        // used to create unique keys for the radio buttons
                        keyPrefix={`${groupType}-G${idx}-F${idx2}`}
                    />
                </div>
            )}
        </div>
    );
};

export default CustomSearchField;
